export default __webpack_public_path__ + "static/media/flashingarc3.9db17f21.png";